<template>
  <validation-observer ref="createReportFormRef">
    <custom-callout
      class-main="rounded"
      :has-toggle="false"
      border-color="green"
    >
      <div class="row bg-secondary-3 pb-3 mx-0 mx-md-n3">
        <div class="col ml-n0 ml-md-n3">
          <icon-view
            icon-background="#2DB782"
            icon="fas fa-file-plus color-white"
            icon-size="0.8rem"
            title="Crear Reporte"
            variant="custom-icon-view ml-n1"
          />
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              label="Año Académico:"
              v-model="academicYear"
              :clearable="false"
              fieldkey="id"
              fieldname="name"
              :options="options"
              placeholder="Seleccione"
              custom-error-msg="El año académico es requerido."
              :error="errors[0]"
              class="ml-0 ml-sm-0 ml-md-4 pl-1 pl-md-3 mt-n2"
            />
          </validation-provider>
        </div>
        <div class="col d-flex align-items-end justify-content-end mt-2 mt-md-0">
          <action-button
            :i="`fas fa-times-circle`"
            variant="outline-danger m-1 btn-block-xs-only"
            @click="onCancelHandler"
            text="Cancelar"
          />
          <action-button
            i="fas fa-arrow-alt-circle-right"
            variant="success m-1 btn-block-xs-only"
            @click="onContinueHandler"
            text="Continuar"
          />
        </div>
      </div>
    </custom-callout>
  </validation-observer>
</template>

<script>
import CustomCallout from "custom-callout";
import CustomDropDown from "custom-drop-down";
import ActionButton from "ActionButton";
import IconView from "icon-view";

export default {
  name: "CreateReportPanel",
  components: {
    CustomCallout,
    CustomDropDown,
    ActionButton,
    IconView,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    academicYear: null,
  }),
  mounted() {
      if(this.options.length > 0 )
      this.academicYear = this.options.find(e => e.selected);
  },
  methods: {
    onCancelHandler() {
      this.$emit("on-cancel");
    },
    async onContinueHandler() {
      const isValid = await this.$refs.createReportFormRef.validate();
      if (!isValid) {
        this.ShowToast(
          "Información Incompleta",
          "Favor completar la información solicitada para poder continuar.",
          "error"
        );
        return;
      }
      this.$emit("on-continue", this.academicYear?.id);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/variables/colors.scss";

.custom-icon-view ::v-deep {
  margin-bottom: 1rem;
  .dot {
    .title-icon {
      margin: 0 !important;
    }
  }
  .font-16.color-gray-7 {
    font-size: 1rem !important;
    color: map-get($colors, "dark-gray") !important;
  }
}
</style>
